import { render } from "./loadingPage.vue?vue&type=template&id=664b7291&scoped=true"
import script from "./loadingPage.vue?vue&type=script&lang=js"
export * from "./loadingPage.vue?vue&type=script&lang=js"

import "./loadingPage.vue?vue&type=style&index=0&id=664b7291&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b7291"]])

export default __exports__